import { FC, useMemo } from 'react';
import { RiskProfileSignal } from '@/api';
import { useAppSelector } from '@/redux/hooks';
import { SignalTableRow } from '@/redux/models';
import { riskscoreProfilesSelectors } from '@/redux/selectors';
import { Input as AntInput, Select as AntSelect, Form } from 'antd';
import { RiskProfileInfluenceEnum, SIGNAL_INFLUENCES } from '@/config';
import { Button } from '@/components/Button';

import { useTranslation } from 'react-i18next';
import styles from './SignalExpandedRow.module.sass';

interface SignalExpandedRowProps {
  signal: SignalTableRow;
  submitHandler: (data: RiskProfileSignal) => void;
}

const SignalExpandedRow: FC<SignalExpandedRowProps> = (props) => {
  const { signal, submitHandler } = props;
  const { t } = useTranslation();
  const [riskForm] = Form.useForm();
  const { profileLoading } = useAppSelector(
    riskscoreProfilesSelectors.getRiskscoreProfilesSlice,
  );

  const selectOptions = useMemo(() => {
    return Object.keys(SIGNAL_INFLUENCES).map((entry) => {
      return {
        key: entry,
        value: entry,
        label: SIGNAL_INFLUENCES[entry as RiskProfileInfluenceEnum],
      };
    });
  }, []);

  const onFinish = (values: Record<string, any>) => {
    const updates: RiskProfileSignal = {
      key: signal.key,
      score: values.riskscore,
      received: values.received,
      sent: values.sent,
    };
    submitHandler(updates);
  };

  const onFinishFailed = () => {};

  const onReset = () => riskForm.resetFields();
  const triggerSubmit = () => riskForm.submit();

  return (
    <div className={styles.row}>
      <div className={styles.inner}>
        <div className={styles.first} />
        <Form
          form={riskForm}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={signal}
          layout="inline"
          variant="borderless"
          autoComplete="off"
          className={styles.setting_form__direction}
        >
          <div className={styles.setting_form__data}>
            <div className={styles.fieldGroup}>
              <Form.Item
                name="riskscore"
                rules={[
                  {
                    type: 'integer',
                    min: 0,
                    max: 100,
                    transform: (val) => Number(val),
                    message: '',
                  },
                ]}
                noStyle
              >
                <AntInput style={{ width: '100%' }} />
              </Form.Item>
            </div>
            <div className={styles.fieldGroup}>
              <Form.Item
                name="received"
                rootClassName={styles.selectWrap}
                noStyle
              >
                <AntSelect
                  options={selectOptions}
                  styles={{ popup: { root: { zIndex: 3500 } } }}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </div>
            <div className={styles.fieldGroup}>
              <Form.Item name="sent" rootClassName={styles.selectWrap} noStyle>
                <AntSelect
                  options={selectOptions}
                  styles={{ popup: { root: { zIndex: 3500 } } }}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </div>
          </div>
          <div className={styles.actions}>
            <Button
              type="secondary-red"
              corner="rect"
              size="xs"
              onClick={onReset}
              isLoading={profileLoading}
            >
              {t('translation.reset')}
            </Button>
            <Button
              type="primary"
              corner="rect"
              size="xs"
              onClick={triggerSubmit}
              isLoading={profileLoading}
            >
              {t('translation.save_changes_btn')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SignalExpandedRow;
